import { EWalletId } from '@ankr.com/provider';
import { stringify } from 'query-string';
import { encodeQueryParams, StringParam } from 'use-query-params';

import { HOMEPAGE, WALLET_PARAM_ID } from 'modules/common';

import packageJSON from '../../../../package.json';

export function getMobileWalletCallbackURL(walletId: EWalletId): string {
  const encodedQuery = encodeQueryParams(
    { [WALLET_PARAM_ID]: StringParam },
    { [WALLET_PARAM_ID]: walletId },
  );

  return `${window.location.origin}${
    packageJSON.homepage
  }/${HOMEPAGE}/?${stringify(encodedQuery)}`;
}
